import { useMemo } from 'react';
import { PaymentType } from '../../../types/common';
import { STORE_PROPS } from '../../constants';
import { usePaymentsStore } from '../../store';

const { PAYMENT_SERVICES, ACTIVE_PAYMENT_TYPE } = STORE_PROPS;

export const useGetPaymentSystemsByType = () => {
  const { paymentServices, activePaymentType } = usePaymentsStore([
    PAYMENT_SERVICES,
    ACTIVE_PAYMENT_TYPE
  ]);

  const { ids = [], data = {} } =
    paymentServices?.[activePaymentType as PaymentType] || {};
  return useMemo(() => ids.map((id: number) => data[id]) || [], [ids, data]);
};
